// 引入组件样式配置信息
const LoginComStyleConfig = () => import(
    /* webpackChunkName: "com_style_loginCom_config" */
    './LoginComStyle'
);

export default LoginComStyleConfig;